// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p.sc-alert__text{margin-bottom:0}
`, "",{"version":3,"sources":["webpack://./src/modules/intelligent-gaming/components/PlayerInformationModal.vue"],"names":[],"mappings":"AACA,iBAEE,eAAgB","sourcesContent":["\np.sc-alert__text {\n  // Bootstrap adds padding to paragraphs\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
